<template>
  <div class="d-flex flex-xl-nowrap flex-wrap h-100">
    <div class="wt-dashborad-chart position-relative" :style="copied_providers.length == 0?'width: 100%':''">
      <div class="wt-dashborad-chart-header py-2 mb-5" v-if="providerId">
        <div class="d-flex justify-content-between">
          <h3> {{ providerId ? selected_provider.providerName : 'CopyTrade' }}</h3>
          <div class="wt-dashborad-chart-header-total d-flex align-items-center">
            <ul class="list-unstyled d-flex p-0">
              <li class="wt-dashborad-chart-header-total-box">
                <span class="wt-dashborad-chart-header-total-label">{{$t('trades')}}: </span>
                <span class="wt-dashborad-chart-header-total-value ms-1">{{openTradeListFiltered.length}} </span>
              </li>
              <!-- <li class="wt-dashborad-chart-header-total-box">
                <span class="wt-dashborad-chart-header-total-label">Profit: </span>
                <span class="wt-dashborad-chart-header-total-value ms-1">&dollar;49.23
                </span>
              </li>
              <li class="wt-dashborad-chart-header-total-box total-win">
                <span class="wt-dashborad-chart-header-total-label">Win Rate: </span>
                <span class="wt-dashborad-chart-header-total-value ms-1">85.3% </span>
              </li> -->
            </ul>
          </div>
        </div>
      </div>

      <!-- <img src="../../../../static/website/images/dashboard-chart.png" class="w-100 chart-img"> -->
      <app-loader v-if="pageLoader"/>
      <UserEquityChart :providerId="providerId" :timeFrame="selectedTimeframe" @callApiHit="getUserEquityChart"
        v-else-if="!pageLoader && providerId && (Object.keys(userEquityChartWithLeader).length && userEquityChartWithLeader.series.length && userEquityChartWithLeader.series[0].data.length)" />
      <div
        v-else
        class="nodataFound d-flex justify-content-center align-items-center position-relative text-center h-100">
        <div class="boxedNodata">
            <div class="noDataPic">
                <img src="../../../../static/website/images/no-data.svg" alt="" />
                <div class="py-2" @click="goToLeaders(2)">
                    <a href="javascript::void(0);" class="btn appButton linkBG mx-auto justify-content-center  mw-100 mx-auto">{{$t('add_more_leader')}}</a>
                </div>
            </div>
        </div>
        <!-- <img src="../../../../../static/hanko/images/new/errorGraphCandle.png" alt="graph" /> -->
      </div>
      <div class="wt-dashborad-chart-footer mt-3 mb-2 mx-auto" v-if="(Object.keys(userEquityChartWithLeader).length && userEquityChartWithLeader.series.length && userEquityChartWithLeader.series[0].data.length)">
        <ul class="d-flex p-0">
          <li v-for="item, key in timeFrameList" @click.prevent.stop="selectedTimeframe = key; getUserEquityChart()"
            :class="{ 'active': selectedTimeframe == key }">{{ item }}</li>
        </ul>
      </div>
    </div>
    <div class="wt-dashborad-leader mt-5 mt-xl-0" v-if="copied_providers.length > 0">
      <div class="wt-dashborad-leader-list wt-scroll">
        <div class="position-relative" v-for="copied_provider in copied_providers" :key="copied_provider.providerId"
            :class="{ 'gaurd-enable': !copied_provider.capitalProtectionAmount }"
            @click.prevent="setSelectedProvider(copied_provider.providerId)">
          <div class="wt-dashborad-leader-card mb-2 position-relative "
            :class="{ 'active': copied_provider.providerId == providerId }"
            >
            <div class="d-flex justify-content-between">
              <div class="wt-dashborad-leader-card-left d-flex align-items-center">
                <img class="wt-dashborad-leader-card-profileImg mr-2" width="50" height="50"
                  v-if="copied_provider && copied_provider.providerId && copied_provider.avatarURL"
                  :src="copied_provider.avatarURL" :alt="copied_provider.providerId * 9"
                  :title="copied_provider.providerId * 9">
                <span class="wt-dashborad-chart-right-card-name">{{ copied_provider.providerName || '' }}</span>
              </div>
              <div class="wt-dashborad-leader-card-right d-flex align-items-center">
                <div class="wt-dashborad-leader-card-right-label text-right">
                  <span class="d-block wt-label">{{$t('total_Profit')}}:</span>
                  <span class="wt-label">{{$t('invested')}}:</span>
                </div>
                <div class="wt-dashborad-leader-card-right-value text-right ml-1">
                  <span class="d-block wt-value">
                    {{ formatCurrency(copied_provider.realizedPnl || 0,accountList.Currency || 'USD') }}
                  </span>
                  <span class="invest wt-value invested">
                    {{ formatCurrency(copied_provider.capitalProtectionAmount || 0,accountList.Currency || 'USD') }}
                  </span>
                </div>
                <div class="wt-dashborad-leader-card-right-value text-right ml-1"  @click.stop="">
                  <a href="javascript:void(0)" class="position-relative ">        
                    <feather type="more-vertical" size="24px" @click="showEdit == copied_provider.providerId?showEdit = null: showEdit = copied_provider.providerId;"></feather>        
                    <!-- <img class="cursor-pointer" src="../../../../static/website/images/toggle.svg" alt=""> -->
                  </a>
                  <div class="wt-dashboard-leader-card-right-dropdown custonDropDown dropdown-menu" v-if="showEdit == copied_provider.providerId">
                    <ul class="statusCom">
                        <li class="border border-bottom f-14 text-center" @click.stop="editDelete(copied_provider)">
                          <a href="javascript:void(0)">{{ !copied_provider.capitalProtectionAmount ? 'Remove' : 'Edit' }}</a>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- ===== gaurd enable modal start===== -->
            <div class="wt-dashborad-leader-card-modal d-flex flex-column justify-content-center align-items-center mt-2 radius-4" v-if="!copied_provider.capitalProtectionAmount">
                <div class="d-flex">
                  <img src="../../../../static/website/images/gaurd-enable-ico.svg" alt="">
                  <span class="red f-14 fw-600">{{$t('market101_guard_enabled')}}</span>
                </div>
                <p class="f-12">{{$t('excessive_losses')}}</p>
            </div>
            <!-- ===== gaurd enable modal end===== -->
          </div>
        </div>
      </div>
      <div class="py-2" @click="goToLeaders(2)">
        <a href="javascript::void(0);" class="btn appButton linkBG mx-auto justify-content-center  mw-100 mx-auto">{{$t('add_more_leader')}}</a>
      </div>
    </div>
    <app-follow v-if="followId" :followId="followId" :followName="followName" @close="followId = ''" @backToDashboard=""></app-follow>
  </div>
</template>
<script>
import { commonAllmixins } from "@/plugins/commonAll";
import UserEquityChart from "./leader-detail/Charts/userEquityChartWithLeader"
import AppFollow from './follow.vue';
export default {
  mixins: [commonAllmixins],
  emits: ['updateTab','updateProviderId'],
  data() {
    return {
      updateProvidrID: 0,
      providerId: 0,
      stopLeader: false,
      selectedTimeframe: '10000',
      timeFrameList: {
        "1": "1D",
        "3": "3D",
        "7": "7D",
        "30": "1M",
        "90": "3M",
        "180": "6m",
        "365": "1Y",
        // "540":"540",
        "10000": "Overall",
      },
      showEdit: null,
      followId: null,
      followName: null,
    }
  },
  components: { UserEquityChart, AppFollow },
  computed: {
    openTradeListFiltered(){
      return this.openTradeList.filter(v=>v.Commentary.includes(this.providerId)) || []
    },
    selected_provider() {
      let provider = this.copied_providers.find(provider => provider.providerId == this.providerId);
      return provider;
    },
    copied_providers() {
      if (Object.keys(this.followersSetting).length && this.followersSetting.providers && this.followersSetting.providers.length) {
        var copied = [];
        if (Object.keys(this.userCopytradingDetails) && this.userCopytradingDetails.zulu && this.userCopytradingDetails.zulu.zulu_account_id) {
            copied = this.followersSetting.providers.filter(provider => provider.zuluAccountId == this.userCopytradingDetails.zulu.zulu_account_id);
        } else {
            copied = []; // or any default value you want to assign if the conditions are not met
        }
        this.copying = copied.length;
        this.totalRecords = copied.length;
        if (copied.length > 0) {
          // this.providerId = copied[0].providerId;
          if (!this.providerId && !this.stopLeader)
            this.setSelectedProvider(copied[0].providerId)
        }
        return copied
        // copied = copied.splice((this.page-1) * this.pageLimit  , (this.page*this.pageLimit) -1)
        // return copied.splice((this.page-1) * this.pageLimit  ,this.pageLimit);
      } else {
        return []
      }
    },
  },
  methods: {
    showSymbol(currency) {
      switch (currency) {
        case 'USD':
          return "$";
          break;
        case 'EUR':
          return "€";
          break;
        case 'CAD':
          return "$";
          break;
        case "GBP":
          return "£";
          break;
        case 'AUD':
          return "A$";
          break;
        default:
          return '$'
          break;
      }
    },
    editDelete(provider){
      this.showEdit = null;
      if(!provider.capitalProtectionAmount){
        let postApi = `${provider.providerId}?targetZuluAccountId=${provider.zuluAccountId}&closeAllTrades=true`
        this._runFollowTrade({ globalParams: {}, localParams: { parameter: this, postApi , isDelete : true } });
      }else{
        this.followId = provider.providerId
        this.followName = provider.providerName
      }
    },
    getResponse(){
      this._runGetFollowersSetting({ globalParams: {}, localParams: { parameter: this, checkValue : true } });
    },
    checkFollow(){
      this.followId = null;
      this.followName = null;
      if (Object.keys(this.followersSetting).length && this.followersSetting.providers && this.followersSetting.providers.length) {
        var copied = [];
        if (Object.keys(this.userCopytradingDetails) && this.userCopytradingDetails.zulu && this.userCopytradingDetails.zulu.zulu_account_id) {
            copied = this.followersSetting.providers.filter(provider => provider.zuluAccountId == this.userCopytradingDetails.zulu.zulu_account_id);
        } else {
            copied = []; // or any default value you want to assign if the conditions are not met
        }
        this.copying = copied.length;
        this.totalRecords = copied.length;
        if (copied.length > 0) {
          let findID = copied.find(v=>v.providerId == this.providerId)
          if (!findID)
            this.setSelectedProvider(copied[0].providerId)
        }else{
          this.providerId = null;
        }
      } else {
        this.providerId = null;
      }
    },
    goToLeaders(tab) {
      this.$emit('updateTab', tab)
    },
    getUserEquityChart() {
      this._runGetUserEquityChartWithLeader({ globalParams: {}, localParams: { 'provider_id': this.providerId, brokerAccountId: this.userCopytradingDetails.zulu.zulu_broker_account_id, timeframe: this.selectedTimeframe, 'type': 'PROFIT_PNL', 'timespan': 'DAILY', parameter: this } });
    },
    setSelectedProvider(provider) {
      this.showEdit = null;
      if (this.providerId != provider) {
        this.providerId = provider;
        this.$emit('updateProviderId', this.providerId,this.selected_provider.providerName)
        this.getUserEquityChart()
      }
    }
  },
  created() {

  }
}
</script>


// WEBPACK FOOTER //
// src/components/website/copy-trade/dashboard.vue